/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Last_Cute_Donkey_HealInputs */

const fr_last_cute_donkey_heal = /** @type {(inputs: Last_Cute_Donkey_HealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thème mis à jour`)
};

/**

* @param {Last_Cute_Donkey_HealInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const last_cute_donkey_heal = /** @type {((inputs?: Last_Cute_Donkey_HealInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_Cute_Donkey_HealInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_last_cute_donkey_heal(inputs)
});